"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperShape = void 0;
const math_1 = require("../../math");
const ShapeLoop_1 = require("../ShapeLoop");
/**
 * ShperShape
 *
 * @category Shapes.ShapeLoop
 * @class SuperShape
 * @extends {ShapeLoop}
 */
class SuperShape extends ShapeLoop_1.ShapeLoop {
    /**
     * Creates an instance of SuperShape.
     *
     * @param {ISuperShapeSettings} [settings={}]
     * @memberof SuperShape
     */
    constructor(settings = {}) {
        var _a, _b, _c, _d, _e, _f;
        settings.type = 'SuperShape';
        settings.loopDependencies = (settings.loopDependencies || []).concat(['a', 'b', 'm', 'n1', 'n2', 'n3']);
        super(settings, true);
        this.props.a = (_a = settings.a) !== null && _a !== void 0 ? _a : 1;
        this.props.b = (_b = settings.b) !== null && _b !== void 0 ? _b : 1;
        this.props.m = (_c = settings.m) !== null && _c !== void 0 ? _c : 6;
        this.props.n1 = (_d = settings.n1) !== null && _d !== void 0 ? _d : 1;
        this.props.n2 = (_e = settings.n2) !== null && _e !== void 0 ? _e : 1;
        this.props.n3 = (_f = settings.n3) !== null && _f !== void 0 ? _f : 1;
        this.loop = {
            start: 0,
            end: math_1.PI2,
            inc: propArguments => {
                const sideLength = this.getRepetitionSideLength(propArguments);
                return Math.PI / Math.pow(sideLength[0] * sideLength[1], 0.5);
            },
            vertex: (shapeLoopRepetition) => {
                const angle = shapeLoopRepetition.current;
                const m = (this.m * angle) / 4;
                const a = Math.abs(Math.cos(m) / this.a) ** this.n2;
                const b = Math.abs(Math.sin(m) / this.b) ** this.n3;
                const raux = (a + b) ** (1 / this.n1);
                const r = raux === 0 ? 1 : 1 / raux;
                return [r * Math.cos(angle), r * Math.sin(angle)];
            },
        };
        this.bStaticLoop = this.isStaticLoop();
        this.bStatic = this.isStatic();
        this.bStaticIndexed = this.isStaticIndexed();
    }
    generateLoopBuffer(propArguments) {
        this.a = this.getProp('a', propArguments);
        this.b = this.getProp('b', propArguments);
        this.m = this.getProp('m', propArguments);
        this.n1 = this.getProp('n1', propArguments);
        this.n2 = this.getProp('n2', propArguments);
        this.n3 = this.getProp('n3', propArguments);
        return super.generateLoopBuffer(propArguments);
    }
}
exports.SuperShape = SuperShape;
//# sourceMappingURL=SuperShape.js.map